<nav class="navbar">
  <div class="container-fluid">
    <button #navbarToggleButton class="navbar-toggler p-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand mx-auto" routerLink="/client">
      <app-logo></app-logo>
    </a>

    <div class="nav-item">
      <a class="text-decoration-none" routerLink="/client/order">
        <img src="assets/images/icons/cart-black.svg" alt="" />
      </a>
    </div>

    <div #navbarCollapse class="collapse navbar-collapse" id="navbarSupportedContent">
      <ng-content></ng-content>
    </div>
  </div>
</nav>
